import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { formatCurrency, formatDate } from '../../lib/utils';

const RapportsTab = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('2024-09');
  const [reportType, setReportType] = useState('paie');

  const generateReport = (type) => {
    // TODO: Générer le rapport réel
    console.log(`Génération du rapport ${type} pour la période ${selectedPeriod}`);
    // Simuler le téléchargement
    const filename = `rapport_${type}_${selectedPeriod}.csv`;
    alert(`Téléchargement du fichier: ${filename}`);
  };

  return (
    <div className="space-y-6">
      {/* Sélection de période */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <span className="mr-2">📅</span>
            Sélection de période
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-4 items-center">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Période
              </label>
              <Input
                type="month"
                value={selectedPeriod}
                onChange={(e) => setSelectedPeriod(e.target.value)}
                className="w-auto"
              />
            </div>
            <div className="flex space-x-2">
              <Button 
                variant="outline" 
                size="sm"
                onClick={() => setSelectedPeriod('2024-08')}
              >
                Mois dernier
              </Button>
              <Button 
                variant="outline" 
                size="sm"
                onClick={() => setSelectedPeriod(new Date().toISOString().slice(0, 7))}
              >
                Mois actuel
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Rapports de paie */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <span className="mr-2">💰</span>
            Rapports de paie
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 mb-4">
            Générez les fichiers nécessaires pour intégrer les retenues dans votre logiciel de paie.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <h4 className="font-medium text-gray-900 mb-2">📋 Fichier de retenues</h4>
              <p className="text-sm text-gray-600 mb-3">
                Export CSV des montants à retenir sur les salaires pour la période sélectionnée.
              </p>
              <div className="space-y-2">
                <Button 
                  className="w-full"
                  onClick={() => generateReport('retenues')}
                >
                  📤 Télécharger CSV
                </Button>
                <div className="text-xs text-gray-500">
                  Format: EntrepriseID, Periode, Matricule, Nom, Prenom, MontantRetenue, ReferenceDemande
                </div>
              </div>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4">
              <h4 className="font-medium text-gray-900 mb-2">📊 Rapport détaillé</h4>
              <p className="text-sm text-gray-600 mb-3">
                Rapport complet avec détails des avances et remboursements.
              </p>
              <div className="space-y-2">
                <Button 
                  variant="outline" 
                  className="w-full"
                  onClick={() => generateReport('detail')}
                >
                  📤 Télécharger PDF
                </Button>
                <div className="text-xs text-gray-500">
                  Inclut: montants, frais, dates, statuts
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-3">
            <h5 className="font-medium text-blue-900 mb-1">💡 Intégration logiciel de paie</h5>
            <p className="text-blue-700 text-sm">
              Le fichier CSV peut être importé directement dans la plupart des logiciels de paie 
              pour automatiser les retenues sur salaire.
            </p>
          </div>
        </CardContent>
      </Card>

      {/* Rapports financiers */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <span className="mr-2">📈</span>
            Rapports financiers
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="border border-gray-200 rounded-lg p-4 text-center">
              <div className="text-2xl mb-2">💸</div>
              <h4 className="font-medium text-gray-900 mb-2">Flux de trésorerie</h4>
              <p className="text-sm text-gray-600 mb-3">
                Entrées et sorties de votre solde
              </p>
              <Button 
                variant="outline" 
                size="sm" 
                className="w-full"
                onClick={() => generateReport('tresorerie')}
              >
                📊 Générer
              </Button>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4 text-center">
              <div className="text-2xl mb-2">📋</div>
              <h4 className="font-medium text-gray-900 mb-2">Synthèse mensuelle</h4>
              <p className="text-sm text-gray-600 mb-3">
                Résumé de l'activité du mois
              </p>
              <Button 
                variant="outline" 
                size="sm" 
                className="w-full"
                onClick={() => generateReport('synthese')}
              >
                📊 Générer
              </Button>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4 text-center">
              <div className="text-2xl mb-2">👥</div>
              <h4 className="font-medium text-gray-900 mb-2">Analyse employés</h4>
              <p className="text-sm text-gray-600 mb-3">
                Utilisation par employé
              </p>
              <Button 
                variant="outline" 
                size="sm" 
                className="w-full"
                onClick={() => generateReport('employes')}
              >
                📊 Générer
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Historique des exports */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <span className="mr-2">📚</span>
            Historique des exports
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {/* Exemple d'historique */}
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center space-x-3">
                <div className="text-green-600">📊</div>
                <div>
                  <p className="font-medium text-gray-900">Rapport retenues - Septembre 2024</p>
                  <p className="text-sm text-gray-600">Généré le 07/09/2024 à 14:30</p>
                </div>
              </div>
              <div className="flex space-x-2">
                <Button size="sm" variant="outline">
                  📤 Re-télécharger
                </Button>
                <Button size="sm" variant="outline">
                  👁️ Aperçu
                </Button>
              </div>
            </div>
            
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center space-x-3">
                <div className="text-blue-600">📋</div>
                <div>
                  <p className="font-medium text-gray-900">Synthèse mensuelle - Août 2024</p>
                  <p className="text-sm text-gray-600">Généré le 02/09/2024 à 09:15</p>
                </div>
              </div>
              <div className="flex space-x-2">
                <Button size="sm" variant="outline">
                  📤 Re-télécharger
                </Button>
                <Button size="sm" variant="outline">
                  👁️ Aperçu
                </Button>
              </div>
            </div>
          </div>
          
          {/* Bouton pour voir plus */}
          <div className="text-center mt-4">
            <Button variant="outline" size="sm">
              Voir tous les exports
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Planification automatique */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <span className="mr-2">⏰</span>
            Planification automatique
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 mb-4">
            Configurez la génération automatique de vos rapports mensuels.
          </p>
          
          <div className="space-y-4">
            <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg">
              <div>
                <p className="font-medium text-gray-900">Rapport de retenues mensuel</p>
                <p className="text-sm text-gray-600">Généré automatiquement le 1er de chaque mois</p>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-green-600 text-sm">✅ Activé</span>
                <Button size="sm" variant="outline">
                  Configurer
                </Button>
              </div>
            </div>
            
            <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg">
              <div>
                <p className="font-medium text-gray-900">Synthèse mensuelle</p>
                <p className="text-sm text-gray-600">Envoyé par email le 2 de chaque mois</p>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-gray-400 text-sm">❌ Désactivé</span>
                <Button size="sm" variant="outline">
                  Activer
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RapportsTab;